import React from 'react';
import { FormBuilder } from 'commons-ui';
import useActivateOffer from './useActivateOffer';
import { ACTIVATE_OFFER_FORM_CONFIG, ACTIVATE_OFFER_LAYOUT, validationSchemaActivateOffer } from '../../utils/formConfig';

const CreateOffer: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useActivateOffer();
	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={validationSchemaActivateOffer}
			setShowLoader={setShowLoader}
			fieldConfig={ACTIVATE_OFFER_FORM_CONFIG}
			layoutConfig={ACTIVATE_OFFER_LAYOUT}
		/>
	);
};

export default CreateOffer;
